module.exports = __webpack_public_path__ + "static/leo-b2d033c0b6510a88673e1d7fbf06bec7.jpg";